import Vue from 'vue'
const ROLES_KEY = 'user-roles'
const NAME_KEY = 'user-key'
const AVATAR_KEY = 'avatar-key'
const COMPANY_NAME_KEY = 'company-name-key'
const PAYMENT_CATEGORIES_KEY = 'payment-categories-key'

export default {
	namespaced: true,
	state() {
		return {
			loginErrors: [],
			isLoading: false,
			roles: (localStorage.getItem(ROLES_KEY) || '')
				.split(',')
				.filter(val => val),
			name: localStorage.getItem(NAME_KEY),
			avatar: localStorage.getItem(AVATAR_KEY),
			companyName: localStorage.getItem(COMPANY_NAME_KEY),
			paymentCategories: (localStorage.getItem(PAYMENT_CATEGORIES_KEY) || '')
				.split(',')
				.filter(val => val),
		}
	},
	getters: {
		hasRole(state) {
			return role => {
				return state.roles && state.roles.includes(role)
			}
		},
	},
	actions: {
		login({ commit, dispatch }, loginData) {
			commit('setLoading', true)
			return new Promise(resolve => {
				commit('setErrors', [])
				Vue.http
					.post('login', loginData)
					.then(response => {
						commit('setName', response.body.name)
						commit('setRoles', response.body.roles)
						commit('setAvatar', response.body.avatar)
						commit('setCompanyName', response.body.company_name)
						commit('setPaymentCategories', response.body.payment_categories)
						commit('setLoading', false)
						dispatch('authReady')
						resolve()
					}, (error) => {
						commit('setErrors', error.body.errors)
						commit('setLoading', false)
					})
					.catch(response => {
						commit('setLoading', false)
						commit('setErrors', response.body.errors)
					})
			})
		},
		async logout({ commit }) {
			commit('setName', null)
			commit('setRoles', null)
			commit('setCompanyName', null)
		},
		async authReady({ dispatch }) {
			dispatch('settings/fetch', null, { root: true })
			dispatch('settings/countryList', null, { root: true })
		}
	},
	mutations: {
		setErrors(state, errors) {
			state.loginErrors = errors
		},
		setLoading(state, status) {
			state.isLoading = status
		},

		setName(state, name) {
			state.name = name
			if (!name) {
				localStorage.removeItem(NAME_KEY)
			} else {
				localStorage.setItem(NAME_KEY, name)
			}
		},

		setRoles(state, roles) {
			state.roles = roles
			if (!roles) {
				localStorage.removeItem(ROLES_KEY)
			} else {
				localStorage.setItem(ROLES_KEY, roles.join())
			}
		},

		setAvatar(state, avatar) {
			state.avatar = avatar
			let fullPathAvatar = Vue.http.options.root + '/files/' + avatar
			if (!avatar) {
				localStorage.removeItem(AVATAR_KEY)
			} else {
				state.avatar = fullPathAvatar
				localStorage.setItem(AVATAR_KEY, fullPathAvatar)
			}
		},

		setCompanyName(state, companyName) {
			if (!companyName) {
				localStorage.removeItem(COMPANY_NAME_KEY)
			} else {
				localStorage.setItem(COMPANY_NAME_KEY, companyName)
			}
			state.companyName = companyName
			Vue.http.headers.common['X-COMPANY-NAME'] = companyName
		},

		setPaymentCategories(state, categories) {
			state.categories = categories
			if (!categories) {
				localStorage.removeItem(PAYMENT_CATEGORIES_KEY)
			} else {
				localStorage.setItem(PAYMENT_CATEGORIES_KEY, categories.join())
			}
		},
	}
}
